import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { AppBar, Hidden, IconButton, Toolbar, makeStyles, Button, Link } from "@material-ui/core";
import InputIcon from "@material-ui/icons/Input";
import { Logo, Typography } from "@packages/ui";
import { Phone } from "@material-ui/icons"
import * as authActions from "src/actions/authActions";
import getBrandFromUrl from "../../utils/getBrandFromUrl";
import getServiceFromUrl from "src/utils/getServiceFromUrl";

const brand = getBrandFromUrl();

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",
    borderBottom: `5px solid ${theme.palette.primary.main}`,
    zIndex: 100,
  },
  logo: {
    marginTop: 5,
    height: brand === "Ace" ? "50px" : brand === "Firefly" ? "45px" : brand == "Dollar" ? "45px" : brand == "Thrifty" ? "45px" : "32px",
  },
  center: {
    flexGrow: 1,
    align: "center",
  },
}));

const TopBar = ({ className, ...rest }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const checkin = useSelector((state) => state.checkin);
  const service = getServiceFromUrl();
  const navigate = useNavigate();
  const isAdditionalDriver = checkin.isAdditionalDriver;
  const resNumber = checkin.resNo;
  const path = `/additional-driver-checkin/login?b=${resNumber}`;

  function logout() {
    console.log(path)

    if (isAdditionalDriver) {
      dispatch(authActions.logout());

      console.log(path)
      // navigate(`${path}`, { replace: true });
      return <Navigate to="/login" />;

      return
    } else {
      dispatch(authActions.logout());
      console.log('Navigate to=/login')
      return <Navigate to="/login" />;
    }
  }

  return (
    <AppBar className={clsx(classes.root, className)} elevation={0} {...rest}>
      <Toolbar>
        <RouterLink to={service === "MJP" ? "/app/rentalhistory" : "/checkin/checkin-form"} className={classes.center}>
          <Logo className={classes.logo} brand={brand} />
        </RouterLink>
        <Hidden mdDown>
        <Typography variant={"h5"} className={classes.center}>
          For Assistance <Phone fontSize="inherit"/> { brand == "Thrifty" && checkin.country == "AU" ? <Link href="tel:13 61 39">13 61 39</Link> : brand == "Dollar" && checkin.country == "AU" ? <Link href="tel:1800 501 934">1800 501 934</Link> : checkin.country == "AU" ? <Link href="tel:13 30 39">13 30 39</Link>: <Link href="tel:0800 654 321">0800 654 321</Link>}
        </Typography>
        </Hidden>
        <Hidden lgUp>
          <Typography variant={"h6"} className={classes.center}>
            <Phone fontSize="inherit" />  {checkin.country == "AU" && brand == "Thrifty" ? <Link href="tel:13 61 39">13 61 39</Link> : brand == "Dollar" && checkin.country == "AU" ? <Link href="tel:1800 501 934">1800 501 934</Link> : checkin.country == "AU" ? <Link href="tel:13 30 39">13 30 39</Link> : <Link href="tel:0800 654 321">0800 654 321</Link>}
          </Typography>
        </Hidden>
        <Hidden mdDown>
          <Typography variant={"h3"}>Online Check-In</Typography>
        </Hidden>
        <Hidden lgUp>
          <Typography variant={"h5"}>Online Check-In</Typography>
        </Hidden>
        <IconButton onClick={() => logout()}>
          <InputIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

export default TopBar;
